export class FrqFrequenciaMes {
  matServidor: string = null;
  anoMes: string = null;
  inAfastAmamenta: number = null;
  inAfastCompensa: number = null;
  inAfastNaoRemun: number = null;
  inAfastRemuner: number = null;
  inEstendida: number = null;
  inFalta: number = null;
  stAusencia: number = null;
  inFeriado: number = null;
  inFerias: number = null;
  inAbonoAtraso: number = null;
  inLancamentoManual: number = null;
  inLicencaParcial: number = null;
  inRecesso: number = null;
  cdTipoPendencia: number = null;
  inTreinamento: number = null;
  qtHorasAdicComp: number = null;
  qtHorasAdicNot: number = null;
  qtHorasAdicPec: number = null;
  qtHorasAtraso: number = null;
  qtHorasAtrasoAbon: number = null;
  qtHorasComplJorna: number = null;
  qtHorasCreditComp: number = null;
  qtHorasCreditAprv: number = null;
  qtHorasExcedAutPec: number = null;
  qtHorasExcedAutCmp: number = null;
  qtHorasExcDiPec: number = null;
  qtHorasJornada: number = null;
  qtHorasMarcadas: number = null;
  qtHorasSaidaAntec: number = null;
  qtHorasSeComp: number = null;
  qtHorasSePecunia: number = null;
  qtHorasAfastComp: number = null;
  qtHorasTrabalhadas: number = null;

  constructor(d?) {
    if (d) {
      this.matServidor = d.matServidor ? d.matServidor : null;
      this.anoMes = d.anoMes ? d.anoMes : null;
      this.inAfastAmamenta = d.inAfastAmamenta ? d.inAfastAmamenta : null;
      this.inAfastCompensa = d.inAfastCompensa ? d.inAfastCompensa : null;
      this.inAfastNaoRemun = d.inAfastNaoRemun ? d.inAfastNaoRemun : null;
      this.inAfastRemuner = d.inAfastRemuner ? d.inAfastRemuner : null;
      this.inEstendida = d.inEstendida ? d.inEstendida : null;
      this.inFalta = d.inFalta ? d.inFalta : null;
      this.stAusencia = d.stAusencia ? d.stAusencia : null;
      this.inFeriado = d.inFeriado ? d.inFeriado : null;
      this.inFerias = d.inFerias ? d.inFerias : null;
      this.inAbonoAtraso = d.inAbonoAtraso ? d.inAbonoAtraso : null;
      this.inLancamentoManual = d.inLancamentoManual
        ? d.inLancamentoManual
        : null;
      this.inLicencaParcial = d.inLicencaParcial ? d.inLicencaParcial : null;
      this.inRecesso = d.inRecesso ? d.inRecesso : null;
      this.cdTipoPendencia = d.cdTipoPendencia ? d.cdTipoPendencia : null;
      this.inTreinamento = d.inTreinamento ? d.inTreinamento : null;
      this.qtHorasAdicComp = d.qtHorasAdicComp ? d.qtHorasAdicComp : null;
      this.qtHorasAdicNot = d.qtHorasAdicNot ? d.qtHorasAdicNot : null;
      this.qtHorasAdicPec = d.qtHorasAdicPec ? d.qtHorasAdicPec : null;
      this.qtHorasAtraso = d.qtHorasAtraso ? d.qtHorasAtraso : null;
      this.qtHorasAtrasoAbon = d.qtHorasAtrasoAbon ? d.qtHorasAtrasoAbon : null;
      this.qtHorasComplJorna = d.qtHorasComplJorna ? d.qtHorasComplJorna : null;
      this.qtHorasCreditComp = d.qtHorasCreditComp ? d.qtHorasCreditComp : null;
      this.qtHorasCreditAprv = d.qtHorasCreditAprv ? d.qtHorasCreditAprv : null;
      this.qtHorasExcedAutPec = d.qtHorasExcedAutPec
        ? d.qtHorasExcedAutPec
        : null;
      this.qtHorasExcedAutCmp = d.qtHorasExcedAutCmp
        ? d.qtHorasExcedAutCmp
        : null;
      this.qtHorasExcDiPec = d.qtHorasExcDiPec ? d.qtHorasExcDiPec : null;
      this.qtHorasJornada = d.qtHorasJornada ? d.qtHorasJornada : null;
      this.qtHorasMarcadas = d.qtHorasMarcadas ? d.qtHorasMarcadas : null;
      this.qtHorasSaidaAntec = d.qtHorasSaidaAntec ? d.qtHorasSaidaAntec : null;
      this.qtHorasSeComp = d.qtHorasSeComp ? d.qtHorasSeComp : null;
      this.qtHorasSePecunia = d.qtHorasSePecunia ? d.qtHorasSePecunia : null;
      this.qtHorasAfastComp = d.qtHorasAfastComp ? d.qtHorasAfastComp : null;
      this.qtHorasTrabalhadas = d.qtHorasTrabalhadas
        ? d.qtHorasTrabalhadas
        : null;
    }
  }
}
